import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: { padding: 20 },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: { flex: 1, paddingHorizontal: 10 },
  row: { flexDirection: 'row', marginBottom: 0 },
  boldText: { fontFamily: 'Roboto', fontWeight: 'ultrabold' },
  text: { fontSize: 9, display: 'inline-block' },
  textBold: { fontSize: 9, fontWeight: 'bold' },
  columnHeader: {
    width: '10%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '12%',
    padding: 3,
    textAlign: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const CollectionSummaryReport = ({ data }) => {
  console.log(data);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // 🧾 Totals
  const indoorServiceCash = data?.indoorServiceData?.stats?.recd_amt_cash || 0;
  const opdDataCash = data?.opdData?.stats?.recd_amt_cash || 0;
  const opdBillingDataCash = data?.opdBillingData?.stats?.recd_amt_cash || 0;
  const labInvestigationCash = data?.labInvestigationData?.stats?.recd_amt_cash || 0;

  const indoorServiceBank = data?.indoorServiceData?.stats?.recd_amt_bank || 0;
  const opdDataBank = data?.opdData?.stats?.recd_amt_bank || 0;
  const opdBillingDataBank = data?.opdBillingData?.stats?.recd_amt_bank || 0;
  const labInvestigationBank = data?.labInvestigationData?.stats?.recd_amt_bank || 0;

  const indoorServiceCredit = data?.indoorServiceData?.stats?.recd_amt_credit || 0;
  const opdDataCredit = data?.opdData?.stats?.recd_amt_credit || 0;
  const opdBillingDataCredit = data?.opdBillingData?.stats?.recd_amt_credit || 0;
  const labInvestigationCredit = data?.labInvestigationData?.stats?.recd_amt_credit || 0;

  const indoorServiceBoth = data?.indoorServiceData?.stats?.recd_amt_both || 0;
  const opdDataBoth = data?.opdData?.stats?.recd_amt_both || 0;
  const opdBillingDataBoth = data?.opdBillingData?.stats?.recd_amt_both || 0;
  const labInvestigationBoth = data?.labInvestigationData?.stats?.recd_amt_both || 0;

  const refundTotal = data?.paymentRefundData?.stats?.recd_amt || 0;
  const receiptTotals = data?.receiptVoucherData?.stats?.recd_amt || 0;

  // 🧮 Grand Total Calculation
  const totalCash =
    indoorServiceCash + opdDataCash + opdBillingDataCash + labInvestigationCash;
  const totalBank =
    indoorServiceBank + opdDataBank + opdBillingDataBank + labInvestigationBank;
  const totalCredit =
    indoorServiceCredit + opdDataCredit + opdBillingDataCredit + labInvestigationCredit;
  const totalBoth =
    indoorServiceBoth + opdDataBoth + opdBillingDataBoth + labInvestigationBoth;

  const grandTotal =
    totalCash + totalBank + totalCredit + totalBoth + receiptTotals - refundTotal;

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Collection Summary Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            {/* 🏥 HEADER */}
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <Text
              style={{ ...styles.boldText, textAlign: 'center', fontSize: 10 }}
              content="BILL WISE COLLECTION SUMMARY"
            />

                       <View style={styles.row}>
              <Text style={{...styles.columnHeader, width:'9%'}} content="Sr No." />
              <Text style={styles.columnHeader} content=" Bill Date" />
              <Text style={styles.columnHeader} content="Opd Type" />
              <Text style={{ ...styles.columnHeader, width: '25%' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={styles.columnHeader} content="Paymode" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Consultant" />                                                                                          
              <Text style={{ ...styles.columnHeader, width: '17%' }} content="Services" />
              <Text style={{...styles.columnHeader, width: '13%'}} content="Panel" />
              <Text style={{ ...styles.columnHeader,  }} content="Credit Amt." />
              <Text style={{ ...styles.columnHeader,  }} content="Recd1" />
              <Text style={{ ...styles.columnHeader,  }} content="Recd2" />
              <Text style={{ ...styles.columnHeader,  }} content="Recd Amt." />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD " /> 
            </View>
            {data &&
              data?.opdData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="OPD" />
                  <Text style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.name_suffix} ${data.first_name} ${data.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.adm_no_date} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content="Consultancy" />
                  <Text style={{...styles.columnContent, width: '11%', textAlign:'left' }} content={data.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.bal} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={""} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={""} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.recd} />
                </View>
              ))}
            <View style={{ marginLeft: '76%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '84%', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="OPD TOTAL : " />
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={Math.round(data?.opdData?.stats?.recd_amt)} />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD Billing" />
            </View>
            {data &&
              data?.opdBillingData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="OPD Billing" />
                  <Text style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content={data.combinedServiceDetails
                      .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')} />
                  <Text style={{...styles.columnContent, width: '11%', textAlign:'left'}} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.balance_amt} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={`${data?.pay_mode_1 ? `${data.pay_mode_1}-`: ""}${data.rec_amt_1}`} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={`${data?.pay_mode_2 ? `${data.pay_mode_2}-`: ""}${data.rec_amt_2}`} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.total_recd} />
                </View>
              ))}

            <View style={{ marginLeft: '73%', marginTop: '7px', flexDirection: 'row', marginBottom: 0  }}>
              <Text style={{ ...styles.columnContent, width: '80%', fontSize: '8px', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="OPD BILLING TOTAL :" />
              <Text style={{ ...styles.columnContent, width: '41px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.opdBillingData?.stats?.recd_amt} />
            </View>

            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="Receipt Voucher " />
            </View>
            {data &&
              data?.receiptVoucherData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="Receipt Voucher" />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '25%' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.ipd_no} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '20%' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '17%' }} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.received_amount} />
                </View>
              ))}
            <View style={{ marginLeft: '68%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{ ...styles.columnContent, width: '84%', fontSize: "9px", fontFamily: "Roboto", color:'red' }}
                content="RECIEPT VOUCHER TOTAL : "
              />
              <Text
                style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.receiptVoucherData?.stats?.recd_amt}
              />
            </View>

            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text style={{ fontSize: '10px' }} content="Payment Refund Voucher " />
            </View>
            {data &&
              data?.paymentRefundData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '9%' }} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{ ...styles.columnContent, textAlign:'left' }} content="Payment Refund" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.ipd_no} />
                  <Text style={{ ...styles.columnContent, textAlign:'left' }} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content={''} />
                  <Text style={{ ...styles.columnContent, width: '13%', textAlign:'left' }} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={''} />
                  <Text style={{ ...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.amount} />
                </View>
              ))}
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="IPD Billing" />
            </View>
            {data &&
              data?.indoorServiceData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="IPD Billing" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.ipd_no} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width:'20%', textAlign:'left' }} content={data.patient.consultant.name} />
                  <Text
                    style={{ ...styles.columnContent, width:'17%', textAlign:'left' }}
                    content={data.combinedServiceDetails.map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')}
                  />
                  <Text style={{ ...styles.columnContent, width:'13%', textAlign:'left' }} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.balance_amt} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={`${data?.pay_mode_1 ? `${data.pay_mode_1}-`: ""}${data.rec_amt_1}`} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={`${data?.pay_mode_2 ? `${data.pay_mode_2}-`: ""}${data.rec_amt_2}`} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.total_recd} />
                </View>
              ))}
            <View style={{ marginLeft: '71%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '84%', fontSize: "9px", fontFamily: "Roboto", color:'red' }} 
              content="IPD BILLING TOTAL :" />
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.indoorServiceData?.stats?.recd_amt} />
            </View>


            {/* 🧪 LAB INVESTIGATION SUMMARY */}
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="Lab Investigation Billing" />
            </View>
            {data &&
              data?.labInvestigationData?.data?.map((item, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '9%' }} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(item?.date)} />
                  <Text style={{ ...styles.columnContent, textAlign: 'left' }} content="Lab Investigation" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%', textAlign: 'left' }}
                    content={`${item?.patient_name}`}
                  />
                  <Text style={styles.columnContent} content={item.uhid} />
                  <Text style={styles.columnContent} content={item.ipd_no || '-'} />
                  <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={item.pay_mode} />
                  <Text
                    style={{ ...styles.columnContent, width: '20%', textAlign: 'left' }}
                    content={item.doctor?.name || ''}
                  />
                  <Text
                    style={{ ...styles.columnContent, width: '17%', textAlign: 'left' }}
                    content={item.combinedServiceDetails
                      ?.map(({ test_name }) => test_name)
                      .join(', ') || ''}
                  />
                  <Text
                    style={{ ...styles.columnContent, width: '13%', textAlign: 'left' }}
                    content={item.sponsor?.name || ''}
                  />
                  <Text
                    style={{ ...styles.columnContent, textAlign: 'right', marginRight: '10px' }}
                    content={item.balance_amt}
                  />
                  <Text
                    style={{ ...styles.columnContent, textAlign: 'right', marginRight: '10px' }}
                    content={`${item?.pay_mode_1 ? `${item.pay_mode_1}-` : ''}${item.rec_amt_1 || ''}`}
                  />
                  <Text
                    style={{ ...styles.columnContent, textAlign: 'right', marginRight: '10px' }}
                    content={`${item?.pay_mode_2 ? `${item.pay_mode_2}-` : ''}${item.rec_amt_2 || ''}`}
                  />
                  <Text
                    style={{ ...styles.columnContent, textAlign: 'right', marginRight: '10px' }}
                    content={item.total_recd}
                  />
                </View>
              ))}

            <View style={{ marginLeft: '71%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{
                  ...styles.columnContent,
                  width: '84%',
                  fontSize: '9px',
                  fontFamily: 'Roboto',
                  color: 'red'
                }}
                content="LAB INVESTIGATION TOTAL :"
              />
              <Text
                style={{
                  ...styles.columnContent,
                  fontSize: '8px',
                  fontFamily: 'Roboto'
                }}
                content={data?.labInvestigationData?.stats?.recd_amt || 0}
              />
            </View>

            {/* 📊 Final Summary Table */}
            <View style={{ ...styles.row, width: '100%', marginTop: '30px' }}>
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Cash" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Bank" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Credit" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Bank+Cash" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Receipt Vouchers" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Refund" />
            </View>

            <View style={{ ...styles.row }}>
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalCash} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalBank} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalCredit} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalBoth} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={receiptTotals} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={refundTotal} />
            </View>

            {/* 💰 GRAND TOTAL */}
            <View style={{ marginTop: '15px', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <Text
                style={{
                  ...styles.columnContent,
                  fontSize: '11px',
                  fontFamily: 'Roboto',
                  color: 'red',
                  fontWeight: 'bold',
                  textAlign: 'right'
                }}
                content={`GRAND TOTAL (CASH + BANK + CREDIT + BOTH + RECEIPTS - REFUNDS):  ₹ ${grandTotal.toFixed(2)}`}
              />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default CollectionSummaryReport;
